export default __webpack_public_path__ + "static/media/millionbet24_receipt.bfa84c62.png";